<template>
  <div class="vh-100 overflow-hidden">
    <div v-if="previewUrl">
      <b-form-group
        v-if="showTargetGroupSelection"
        class="pt-2 m-0"
        style="height: 50px"
        label-cols="6"
        label-size="sm"
        label-align="right"
        :label="$t('Webportal.AvailableCheckReports')">

        <b-dropdown variant="primary" size="sm">
          <template slot="button-content">
            <span :class="['flag-icon', `flag-icon-${getSurveyInstanceLanguage(selectedSurveyDefaultLocalization)}`]" />&nbsp;
            {{ $t('Webportal.TargetGroup') }} {{ selectedTargetGroup.targetGroup }} ({{ selectedTargetGroup.groupName }})
          </template>
          <b-dropdown-header>{{ $t('Webportal.SurveyDefaultLanguage') }}</b-dropdown-header>
          <b-dropdown-item v-for="targetGroup in targetGroups" :key="`SDL${targetGroup.targetGroup}`"
                           @click="showPreview(true, targetGroup)">
            <span :class="['flag-icon', `flag-icon-${getSurveyInstanceLanguage(true)}`]" />&nbsp;
            {{ $t('Webportal.TargetGroup') }} {{ targetGroup.targetGroup }} ({{ targetGroup.groupName }})
          </b-dropdown-item>
          <b-dropdown-header>{{ $t('Webportal.LocationLanguage') }}</b-dropdown-header>
          <b-dropdown-item v-for="targetGroup in targetGroups" :key="`LL${targetGroup.targetGroup}`"
                           @click="showPreview(false, targetGroup)">
            <span :class="['flag-icon', `flag-icon-${getSurveyInstanceLanguage(false)}`]" />&nbsp;
            {{ $t('Webportal.TargetGroup') }} {{ targetGroup.targetGroup }} ({{ targetGroup.groupName }})
          </b-dropdown-item>
        </b-dropdown>
      </b-form-group>
      <iframe
        class="w-100"
        :style="{ height: `calc(100vh ${(showTargetGroupSelection ? '- 50px' : '')})` }"
        :src="previewUrl"
        frameBorder="0">
      </iframe>
    </div>

    <div v-else class="app flex-row align-items-center h-100">
      <div class="container">
        <div v-if="isLoading" class="row justify-content-center">
          <div class="col-md-5">
            <div class="clearfix">
              <h4 class="pt-3">{{ $t('Webportal.Download.Wait') }}</h4>
            </div>
          </div>
          <div class="col-md-1 inlineSpinner"></div>
        </div>

        <div v-else class="row justify-content-center">
          <div class="col-md-6">
            <div class="clearfix">
              <h4 class="pt-3">{{ $t('Webportal.Download.NichtVorhanden') }}</h4>
              <p>{{ $t('Webportal.Download.NichtVorhandenText') }}</p>

              <h4 class="pt-3">{{ $t('Webportal.Download.NotAvailable') }}</h4>
              <p>{{ $t('Webportal.Download.NotAvailableText') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DownloadService from "@/services/DownloadService";
import { changeLocalization } from "@/i18n";

export default {
  name: "Download",

  data() {
    return {
      previewUrl: null,
      isLoading: false,

      metaInfo: null,
      selectedSurveyDefaultLocalization: true,
      selectedTargetGroup: {}
    };
  },

  computed: {
    targetGroups() {
      return this.metaInfo?.targetGroups;
    },

    showTargetGroupSelection() {
      return this.metaInfo?.showTargetGroupSelection && this.targetGroups?.length > 0
    }
  },

  async mounted() {
    this.isLoading = true;
    try {
      let metaInfoResponse = await DownloadService.getDownloadMetaInformation(
        this.$route.params.token
      );
      this.metaInfo = metaInfoResponse.data;

      if (this.metaInfo)
      {
        changeLocalization(this.metaInfo.userLocalization);

        let useSurveyDefaultLocalization = 
          !(this.metaInfo.userLocalization === this.metaInfo.locationDefaultLocalization ||
            (this.metaInfo.userLocalization.includes('-') && this.metaInfo.locationDefaultLocalization?.includes('-') ?
             this.metaInfo.userLocalization.split('-')[0].toLowerCase() === this.metaInfo.locationDefaultLocalization.split('-')[0].toLowerCase() : false));

        let defaultTargetGroup = 
          this.metaInfo.targetGroups?.find((mir) => mir.isDefault) ??
          (this.metaInfo.targetGroups ? this.metaInfo.targetGroups[0] : null);

        await this.showPreview(useSurveyDefaultLocalization, defaultTargetGroup);
      } else
        await this.showPreview();
    } finally {
      this.isLoading = false;
    }
  },

  methods: {
    getSurveyInstanceLanguage(useSurveyDefault) {
      return useSurveyDefault === false &&
        this.metaInfo.locationDefaultLocalization?.includes('-') ?
        this.metaInfo.locationDefaultLocalization.split('-')[1].toLowerCase() :
        this.metaInfo.surveyDefaultLocalization.split('-')[1].toLowerCase();
    },

    async showPreview(useSurveyDefault, targetGroup) {
      this.isLoading = true;
      this.previewUrl = null;

      let options = { 
        localizationId: !useSurveyDefault ? this.metaInfo?.locationDefaultLocalization : null,
        targetGroup: targetGroup?.targetGroup
      };

      try {
        let fileResponse = await DownloadService.getDownloadFile(
          this.$route.params.token,
          options
        );

        const blobUrl = window.URL.createObjectURL(fileResponse.data);
        this.previewUrl = `${process.env.BASE_URL}static/pdfjs/web/viewer.html?file=${blobUrl}`;

        this.selectedSurveyDefaultLocalization = useSurveyDefault;
        this.selectedTargetGroup = targetGroup ?? this.selectedTargetGroup;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>